[
    {
        "name": "Easy Street",
        "layout": [
            "                                       V                 $                     ",
            "                                                         H                     ",
            "                H                                        H                     ",
            "       =========H==================================================            ",
            "                H                                                              ",
            "                H                                                              ",
            "                H          H                             H                     ",
            "================H==========H==================   ========H=====================",
            "                &          H                             H          |       |  ",
            "                                                         H         Easy Street ",
            "                H                                        H                     ",
            "       =========H==========H=========  =======================                 ",
            "                H                                                              ",
            "                H                                                              ",
            "                H                                        H                     ",
            "======================== ====================== =========H==============       ",
            "                                                         H                     ",
            "                                                         H                     ",
            "*    p                                                   H                    *",
            "==============================================================================="
        ]
    },
    {
        "name": "Long Island",
        "layout": [
            "                                                                          $    ",
            "                                                                   &      H    ",
            "    H       |V                                                     V|     H    ",
            "====H======================= ========================= ======================  ",
            "    H                                                                          ",
            "    H                                                                          ",
            "    H                    & |                         . .                  H    ",
            "========================== ======  =================== ===================H==  ",
            "                                                                          H    ",
            "                                  |                                       H    ",
            "    H                             |                 .  .                  H    ",
            "====H=====================   ======  ================  ======================  ",
            "    H                                                                          ",
            "    H                      |                                                   ",
            "    H                      |                        .   .                 H    ",
            "=========================  ========    ==============   ==================H==  ",
            "                                                                          H    ",
            "==============                      |                                     H    ",
            " Long Island |   p         *        |                 *                   H    ",
            "==============================================================================="
        ]
    },
    {
        "name": "Ghost Town",
        "layout": [
            "                            V               V           V               $      ",
            "                                                                       $$$     ",
            "     p    H                                                    H      $$$$$   H",
            "==========H===                                                =H==============H",
            "          H                                                    H              H",
            "          H                              &                     H              H",
            "     ==============   ====     =    ======    =   ====    =====H=====         H",
            "    G              ^^^    ^^^^^ ^^^^      ^^^^ ^^^    ^^^                     $",
            "    h                                                                 |        ",
            "    o     |                     H                             &       |        ",
            "    s     ======================H============================== ===========    ",
            "    t        &                  H                                              ",
            "                                H                                              ",
            "              |                 H                 H                   H        ",
            "    T         ==================H=================H===================H======= ",
            "    o                                             H                   H        ",
            "    w                                                                 H        ",
            "    n                           ^                                     H        ",
            "*                              ^^^                                    H       *",
            "==============================================================================="
        ]
    },
    {
        "name": "Tunnel Vision",
        "layout": [
            "                                            V                       V          ",
            "                                                                               ",
            "     H             H                         |                H                ",
            "=====H=====--======H==========================     ===----====H===========     ",
            "     H             H                |&&                       H                ",
            "     H             H                ==================        H                ",
            "     H             H                       tunnel  H          H                ",
            "     H           =======---===----=================H=         H           H    ",
            "     H         |                           vision  H          H           H    ",
            "     H         =========---&      -----============H          H           H    ",
            "     H           H                                 H |        H           H    ",
            "     H           H=========----===----================        H  ==============",
            "                 H                                        &   H                ",
            "                 H                                        |   H                ",
            "====---====      H                                        |   H                ",
            "|         |    ================---===---===================   H                ",
            "|   ===   |                                                   H        H    p  ",
            "|    $    |                                                   H     ===H=======",
            "|*  $$$  *|   *                *       *                     *H       *H       ",
            "==============================================================================="
        ]
    },
    {
        "name": "Point of No Return",
        "time": 35,
        "maxRocks": 7,
        "layout": [
            "         $                                                                     ",
            "         H                                                   V                 ",
            "         H                                                                     ",
            "         HHHHHHHHHHHHH     .HHHHHHHHHHHHHH                          H    p     ",
            "         &                   V           H                        ==H==========",
            "                                         H                          H          ",
            "   H                                     H        .                 H          ",
            "===H==============-----------============H====                      H          ",
            "   H                                                      H         H          ",
            "   H                                                 =====H==============      ",
            "   H                                     H                H                    ",
            "   H              &..^^^.....^..^ . ^^   H==---------     H                    ",
            "   H         ============================H    &           H             H      ",
            "   H         ===      ===      ===       H    ---------=================H======",
            "   H                                     H                              H      ",
            "   H                          &          H          &                   H      ",
            "   ==========-------------------------=======----------===================     ",
            "                                                                               ",
            "^^^*         ^^^^^^^^^^^^^^^^^^^^^^^^^*     *^^^^^^^^^^*Point of No Return*^^^^",
            "==============================================================================="
        ]
    },
    {
        "name": "Bug City",
        "layout": [
            "        Bug City             HHHHHHHH                          V               ",
            "                           HHH      HHH                                        ",
            "   H                                          >mmmmmmmm                        ",
            "   H===============                   ====================          H          ",
            "   H              |=====       \\  /         V                  =====H==========",
            "   H                            \\/                                  H          ",
            "   H                                        | $                     H          ",
            "   H           H                            | H                     H          ",
            "   H       ====H=======          p          |&H    H                H          ",
            "   H           H             ======================H           ======          ",
            "   H           H      &|                           H                    H      ",
            "   H           H      &|                    H      H     }{        =====H====  ",
            "===H===&       H       =====================H      H                    H      ",
            "               H                            H      H                    H      ",
            "               H                            H      &                    H      ",
            "         ======H===   =======    H    <>    &                           H      ",
            "                                 H==========       =====     =     ============",
            "     }i{                         H                                             ",
            "*                                H                                            *",
            "==============================================================================="
        ]
    },
    {
        "name": "GangLand",
        "layout": [
            "                    =Gang Land=                             V                  ",
            "                   ==      _  ==                                      .        ",
            "      p    H        |  [] |_| |                  &                    .  H     ",
            "===========H        |     |_| |       H         ===   ===================H     ",
            "      V    H        =============     H======                            H     ",
            "           H                          H                     &            H     ",
            "           H                          H                |    |            H     ",
            "    H      H        ^^^&&^^^ & ^  ^^^ H           H    |    =============H     ",
            "    H======H   =======================H===========H=====          &      H     ",
            "    H                                 H           H    |         &&&     H     ",
            "    H                                 H           H    |        &&&&&    H     ",
            "    H                                 H           H    |    =============H     ",
            "              =====------=================        H    |       $     $         ",
            "                                         |        H    |      $$$   $$$        ",
            "====------===                            |        H    |     $$$$$ $$$$$       ",
            "            |       =                    | =============    ============       ",
            "            |       $                     ^          &                         ",
            "            |^^^^^^^^^^^^^^      $ ^              ======                       ",
            "*                   .      &   ^ H*^                    ^  ^       ^^^^^^^^^^^^",
            "==============================================================================="
        ]
    }
]
